import { hMacAjax as fetch } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
const baseCenterURL = `${baseURL}/grt-user-center-service`,

    teacherDynamicField = `${baseCenterURL}/user-achievement/v1`,
    teacherArea = `${baseCenterURL}/open/geo/v1/parent`;

//分类列表
export function handleTeacherCategoryList(data) {
    return fetch.get(teacherDynamicField + '/data/classification', data);
}
//业绩信息全部详情
export function handleTeacherDynamicFieldDetailAll(data) {
    return fetch.get(teacherDynamicField + '/user', data);
}
//创建业绩信息
export function handleTeacherDynamicFieldAdd(data) {
    return fetch.post(teacherDynamicField + '/add', data);
}
//编辑业绩信息
export function handleTeacherDynamicFieldEdit(data) {
    return fetch.post(teacherDynamicField + '/update', data);
}
//获取数据分类下动态字段
export function handleTeacherCategoryField(data) {
    return fetch.get(teacherDynamicField + '/data/classification/classify', data);
}
//业绩信息单独详情
export function handleTeacherDynamicFieldDetail(data) {
    return fetch.get(teacherDynamicField + '/details', data);
}
//删除业绩信息
export function handleTeacherDynamicFieldDelete(classification_id, id) {
    return fetch.delete(teacherDynamicField + `/delete?classification_id=${classification_id}&id=${id}`);
}
//获取省市县
export function handleTeacherArea(data) {
    return fetch.get(teacherArea, data);
}